{
  "analytics": {
    "title": "Noesis",
    "navigation_title": "Noesis"
  }
}